<template>
  <!-- @detected-condition fires when the connectivity status of the device changes -->
  <offline @detected-condition="handleConnectivityChange">
    <!-- Only renders when the device is online 
    <div slot="online">
      <p>It looks like you're online! Here's all the things you can do...</p>
     
    </div>
    -->
    <!-- Only renders when the device is offline -->
    <div slot="offline">
      <svg
        width="70px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
      >
        <g>
          <path
            style="fill: #8b7e7f"
            d="M256,284.981c-1.856,0-3.712-0.639-5.214-1.917l-31.463-26.751l10.43-12.267L256,266.365
              l26.244-22.314l10.43,12.267l-31.458,26.747C259.712,284.342,257.856,284.981,256,284.981z"
          />
          <path
            style="fill: #8b7e7f"
            d="M256,376.755c-1.597,0-3.193-0.473-4.568-1.422l-58.294-40.183
              c-3.661-2.524,5.477-15.78,9.138-13.257l53.726,37.033l53.72-37.029c3.661-2.522,12.798,10.734,9.138,13.257l-58.289,40.179
              C259.193,376.28,257.596,376.755,256,376.755z"
          />
          <path
            style="fill: #8b7e7f"
            d="M256,468.528c-1.394,0-2.789-0.362-4.037-1.085l-86.339-50.041
              c-3.847-2.229,4.227-16.161,8.073-13.93l82.302,47.701l82.304-47.702c3.846-2.229,11.92,11.7,8.073,13.93l-86.34,50.042
              C258.789,468.167,257.394,468.528,256,468.528z"
          />
        </g>
        <path
          style="fill: #fee191"
          d="M256,220.042c-60.666,0-110.021-49.355-110.021-110.021S195.334,0,256,0
            s110.021,49.355,110.021,110.021S316.666,220.042,256,220.042z M256,16.101c-51.788,0-93.92,42.132-93.92,93.92
            s42.132,93.92,93.92,93.92s93.92-42.132,93.92-93.92S307.788,16.101,256,16.101z"
        />
        <path
          style="fill: #ffd24d"
          d="M256,177.107c-36.991,0-67.086-30.095-67.086-67.086S219.009,42.935,256,42.935
            s67.086,30.095,67.086,67.086S292.991,177.107,256,177.107z M256,59.036c-28.113,0-50.985,22.873-50.985,50.985
            s22.873,50.985,50.985,50.985s50.985-22.873,50.985-50.985S284.113,59.036,256,59.036z"
        />
        <path
          style="fill: #605353"
          d="M364.032,448.931L264.05,156.981v-41.593H247.95v41.595l-99.99,291.971
            c-1.44,4.207,0.802,8.784,5.007,10.225c0.864,0.295,1.744,0.436,2.609,0.436c3.346,0,6.471-2.102,7.616-5.444l84.758-247.495V503.95
            c0,4.446,3.604,8.05,8.05,8.05c4.446,0,8.05-3.604,8.05-8.05V206.677l84.75,247.471c1.442,4.205,6.017,6.45,10.225,5.007
            C363.231,457.715,365.474,453.137,364.032,448.931z"
        />
        <circle style="fill: #f14742" cx="256" cy="110.021" r="16.101" />
      </svg>
      <h5>Please check your internet</h5>

      <p>
        You appear to be <strong>offline</strong>, please check your internet
        connection before using our application.
      </p>
    </div>
  </offline>
</template>

<script>
import offline from 'v-offline'

export default {
  components: {
    offline,
  },

  methods: {
    handleConnectivityChange(status) {},
  },
}
</script>
